import { render, staticRenderFns } from "./shoplist.vue?vue&type=template&id=417c146e&scoped=true&"
import script from "./shoplist.vue?vue&type=script&lang=js&"
export * from "./shoplist.vue?vue&type=script&lang=js&"
import style0 from "./shoplist.vue?vue&type=style&index=0&id=417c146e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "417c146e",
  null
  
)

export default component.exports